import { getFunctions, httpsCallable } from "firebase/functions";
import { useCallback, useContext } from "react";
import { createResult, getFnResponseData } from "../altFunctions/common";
import { AppContext } from "../cnr/contexts/AppProvider";

const _showCallLogs = false

/**
 * 
 * @param {enum} genericType 
 * @param {object} callData 
 * @returns - The  `data` {success,result, error} object from the sp
 */
export const callFunction = async (genericType, callData, useMe, mainFunctions) => {

  const _useMe = !useMe ? true : useMe

  let ft;
  const _keys = Object.keys(callData)

  if (_keys) {
    _keys.forEach(key => {
      if (key.endsWith('FunctionType')) {
        ft = callData[key];
      }
    })
  }

  _showCallLogs && console.log('>>> callFunction: mainFunctions:', mainFunctions)
  _showCallLogs && console.log('>>> callFunction: callData:', genericType, ft, callData)

  try {
    const functions = mainFunctions ? mainFunctions : getFunctions();
    const fn = httpsCallable(functions, genericType);
    const result = await fn(callData)
    _showCallLogs && console.log('<<< callFunction: response:', result)
    return getFnResponseData(result)
  } catch (error) {
    console.log('callFunction - error', genericType, error, callData)
    return createResult(false, {}, error)
  }
}

export const callFunctionDirect = async (functionType, callData, mainFunctions) => {
  const functions = mainFunctions || getFunctions();
  try {
    const _rsp = (await httpsCallable(functions, functionType)(callData))
    _showCallLogs && console.log('callFunctionDirect', functionType, callData, _rsp)
    return getFnResponseData(_rsp)
  } catch (error) {
    console.log('callFunction - error', error)
    return createResult(false, {}, error)
  }
}

export const fsfn_genericCall = async (type) => {
  try {
    const functions = getFunctions();
    const callData = { type }
    const _rsp = (await httpsCallable(functions, 'genericCall')(callData))
    _showCallLogs && console.log('fsfn_genericCall', getFnResponseData(_rsp))
  } catch (error) {
    return { data: { success: false } }
  }
}


